import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import fetchBook from "../../../Redux/BookState/Thunk/fetchBook";
import BookCard from "./BookCard";

const Book = ({search}) => {
  const books = useSelector((state) => state.bookState);
  const dispatch = useDispatch();

  const [featuredFilter, setFeaturedFiltered] = useState(false);

  useEffect(() =>{
    dispatch(fetchBook)
  },[dispatch])
  
  const searchFilter = () => {
    return (book => search ? book.name.toLowerCase().includes(search.toLowerCase()):book)
  }

  const filterByFeatured = () =>{
    return (book => featuredFilter? book.featured : book)
  }

  return (
    <>
      <div className="order-2 xl:-order-1">
        <div className="flex items-center justify-between mb-12">
          <h4 className="mt-2 text-xl font-bold">Book List</h4>

          <div className="flex items-center space-x-4">
            <button
              onClick={() => setFeaturedFiltered(false)}
              className={`filter-btn ${!featuredFilter && 'active-filter'} `}
              id="lws-filterAll"
            >
              All
            </button>
            <button
              onClick={() => setFeaturedFiltered(true)}
              className={`filter-btn ${featuredFilter && 'active-filter'} `}
              id="lws-filterFeatured"
            >
              Featured
            </button>
          </div>
        </div>
        <div className="lws-bookContainer">
          {/* <!-- Card  --> */}
          {
            books.filter(searchFilter())
            .filter(filterByFeatured())
            .map(book => <BookCard key={book.id} book={book}></BookCard>)
          }
        </div>
      </div>
    </>
  );
};

export default Book;
